export default {
    edge_tensor_tab_title: 'AI Video Reviews',
    edge_tensor_tab_row_id: 'Row Id',
    edge_tensor_tab_status: 'Status',
    edge_tensor_tab_unit_time: 'Unit Time',
    edge_tensor_tab_created_on: 'Created On',
    edge_tensor_tab_result: 'Result',
    edge_tensor_tab_load_error: 'Load Error',
    edge_tensor_tab_device_id: 'Device Id',
    edge_tensor_tab_status_complete: 'Complete',
    edge_tensor_tab_status_pending: 'Pending',
    edge_tensor_tab_status_failed: 'Failed',
    edge_tensor_tab_raw_message: 'AI Video Review Raw Message',
    edge_tensor_tab_data: 'Data',
    edge_tensor_tab_response: 'Response',
    edge_tensor_tab_process_time: 'Process Time',
    edge_tensor_tab_results: 'Results',
    edge_tensor_tab_result_events: 'Result Events',
    edge_tensor_tab_event_name: 'Event Name',
    edge_tensor_tab_event_review: 'Event Review',
    edge_tensor_tab_device: 'Device',
    edge_tensor_tab_account: 'Account',
    edge_tensor_tab_date_range: 'Date Range',
    edge_tensor_tab_review_status: 'Review Status',
    edge_tensor_tab_open_video: 'Open Video',
    edge_tensor_no_events: 'No Events',
    edge_tensor_tab_video_url: 'Video URL',
    edge_tensor_tab_confirm: 'Confirm',
    edge_tensor_tab_unknown: 'Unknown',
    edge_tensor_tab_false_positive: 'False Positive',
    edge_tensor_tab_unreviewed: 'Unreviewed'

};